import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { BunkerFlowDirection } from '../../types/api/profile';

interface FlowDirectionDisplayProps {
  flowDirection?: BunkerFlowDirection;
}

export const FlowDirectionDisplay: React.FC<FlowDirectionDisplayProps> = ({ 
  flowDirection,
}) => {
  const { palette } = useTheme();

  const getDisplayText = (): string => {
    if (flowDirection === undefined || flowDirection === BunkerFlowDirection.Undefined) {
      return 'n/a';
    }

    return BunkerFlowDirection[flowDirection];
  };

  return (
    <Typography color={palette.text.primary} sx={{ fontWeight: 500 }}>
      {getDisplayText()}
    </Typography>
  );
}; 